var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedinBlue = function SvgLinkedinBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "linkedin",
    clipPath: "url(#clip0_3966_1571)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M33.9286 0.746094H3.06339C1.64911 0.746094 0.5 1.91127 0.5 3.34163V34.1506C0.5 35.5809 1.64911 36.7461 3.06339 36.7461H33.9286C35.3429 36.7461 36.5 35.5809 36.5 34.1506V3.34163C36.5 1.91127 35.3429 0.746094 33.9286 0.746094ZM11.3804 31.6032H6.04464V14.4229H11.3884V31.6032H11.3804ZM8.7125 12.0765C7.00089 12.0765 5.61875 10.6863 5.61875 8.9827C5.61875 7.27913 7.00089 5.88895 8.7125 5.88895C10.4161 5.88895 11.8062 7.27913 11.8062 8.9827C11.8062 10.6943 10.4241 12.0765 8.7125 12.0765ZM31.3812 31.6032H26.0455V23.2461C26.0455 21.2532 26.0054 18.6898 23.2732 18.6898C20.4929 18.6898 20.067 20.8595 20.067 23.1015V31.6032H14.7313V14.4229H19.85V16.7693H19.9223C20.6375 15.4193 22.3813 13.997 24.9768 13.997C30.3768 13.997 31.3812 17.5568 31.3812 22.1854V31.6032Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3966_1571"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(0.5 0.746094)"
  })))));
};
export default SvgLinkedinBlue;